import React from 'react';

/** Boostrap Components */  
import { Container,Row,Col,Form, Button, Card } from 'react-bootstrap';  
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';

/** Select component */
import Select from 'react-select'

/** Icon components */
import { BsPencilSquare,BsFillTrashFill } from "react-icons/bs";

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';
import SideMenuComponent from './sidemenu';

import { AUTH_URL, FINYEAR_LIST_URL,UPLOAD_MENU_URL, DOCUMENT_LIST, DELETE_URL } from '../utils/constants';

class DocumentListComponent extends React.Component { 
	constructor(props) {
		super(props);
		this.state = {
			pdfFile: '',
			finYear: '',
			id: '',
			items: [],
			finyearList: [],
			title: '',
			isLoaded: false,
			show: false,
			disable: false
		}
		this.onChangeFinyear = this.onChangeFinyear.bind(this);
	}
	handleClose = () =>{
		this.setState({show: false,disable : false});
	}
	onChangeTitle = (event) =>{
		this.setState({title: event.target.value});
	}
	handleShow = event =>{
		let values = event.currentTarget.id.split('|');
		if(values[3] === ''){
			this.setState({disable : true})
		}
		this.setState({show: true,id: values[0],title: values[1],finYear: values[2]});

	}
	componentDidMount() {

		var cf = '';
		var year = new Date().getFullYear();
		if(new Date().getMonth() > 3)
			cf = year+'-'+(year+1);
		else
			cf = (year-1)+'-'+year;

		fetch(AUTH_URL,{method:'POST',headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}})
			.then(res => res.json())
			.then(user => {
	
				this.getDocList(cf);
		
				fetch(FINYEAR_LIST_URL,{method : 'POST'})
					.then(res => res.json())
					.then(
						(result2) => {
							this.setState({
								isLoaded: true,
								finyearList: result2
							});
						},
						(error) => {
							this.setState({
								isLoaded: true,
								error
							});
						}
					)
					})
			.catch(error => {
				alert('Session Expired!!');
				this.props.history("/login");
				return false;
			})

	}

	getDocList = (finyear) => {
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json',Authorization: 'Bearer' },
			body: JSON.stringify({ fin_year: finyear })
		};

		fetch(DOCUMENT_LIST,requestOptions)
			.then(res => res.json())
			.then(
				(result) => {
					if(result.STATUS === 0){
						this.setState({
							isLoaded: true,
							items: result.DATA,
							finYear: finyear
						});
					}
					else
						alert('No data found');
				},
				(error) => {
					this.setState({
						isLoaded: true,
						error
					});
				}
			)

	}
	onChangeFinyear = event => {
		this.getDocList(event.value);
		this.setState({finYear: event.value});

	}
	onFileChange = event => {
		this.setState({ pdfFile: event.target.files[0] });
	};

	onFileUpload = (event) => {
		event.preventDefault();
		const formData = new FormData();
		formData.append("id",this.state.id);
		formData.append("title",this.state.title);
		formData.append("username",sessionStorage.getItem('user'));
		//console.log(this.state)
		if(this.state.pdfFile !== '')
			formData.append("pdfFile", this.state.pdfFile,this.state.pdfFile.name );

		var url = UPLOAD_MENU_URL;

		fetch(url,{method:'POST',body:formData})
			.then(res => res.json())
			.then(
				(result) => {
					alert(result.MESSAGE);
					event.target.reset();
					this.getDocList(this.state.finYear);
					//window.parent.location = window.parent.location.href;
				},
				(error) => {
					alert("Error while uploading")
				}
			)

	};
	deleteMenu = (event) =>{
		event.preventDefault();
		if (window.confirm("Are you sure to delete this menu? ") === true) {
			let id = event.currentTarget.id;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json',Authorization: 'Bearer' },
				body: JSON.stringify({ delete_id: id, username: sessionStorage.getItem('user') })
			};
			fetch(DELETE_URL,requestOptions)
				.then(res => res.json())
				.then(
					(result) => {
						alert(result.MESSAGE);
						if(result.STATUS === 0)
							this.getDocList(this.state.finYear)
					},
					(error) => {
						alert('Could not delete item!!');
					}
				)
		} 
	}

	render() {

		const { items, finyearList, show, id, finYear } = this.state;

		var finyearOptions = [];
		finyearList.forEach(finyear=>{
			finyearOptions.push({value: finyear, label: finyear})
		});
		return (
			<>
				<NavbarComponent/> 
				<nav className="sticky"></nav>
				<div className="App-common main">
					<Container>
						<Row className='mt-3'>
							<Col sm="4" md="3" lg="3">
								<SideMenuComponent/>
							</Col>
							<Col sm="8" md="9" lg="9">
								<Card className="">
									<Card.Body>
									<Row>
										<div style={{fontWeight: "bold",fontSize: "large",marginBottom:"10px",borderBottom:"2px solid #3998ac"}}>
												Uploaded Documents
											</div>
										<Col xs="8" sm="8" md="4" lg="4">
											<Form.Group className="mb-3">
												<Form.Label>Select Financial Year</Form.Label>
												<Select options={finyearOptions} name="finYear" id="finYear" onChange={this.onChangeFinyear}/>
											</Form.Group>
										</Col>
									</Row>
									<Row style={{height: "50vh",overflow: "auto"}}>
										<Col xs="12" md="8" lg="12" sm="12">
											<Table striped bordered hover className='customTable'>
												<thead>
													<tr>
													<th>Financial Year</th>
													<th>Title</th>
													<th>File Uploaded</th>
													<th>Change/Update</th>
													</tr>
												</thead>
												<tbody>
													{items.map(item => 
														(item.child.length === 0 )?
														<tr>
															<td>{item.fin_year}</td>
															<td>{item.name}</td>
															<td>{(item.link === '')?<>MENU</>:<>YES</>}</td>
															<td id={item.id}>
																<span className='p-1'>
																	<Button id={`${item.id}|${item.name}|${item.fin_year}|${item.link}`} variant='info' size='small' onClick={this.handleShow} style={{padding:'0 3px'}}>
																		<BsPencilSquare/>
																	</Button>
																</span>
																<span className='p-1'>
																	<Button id={`${item.id}`} variant='danger' size='small' onClick={this.deleteMenu} style={{padding:'0 3px',backgroundColor:"red",borderColor:"red"}}>
																		<BsFillTrashFill/>
																	</Button>
																</span>
															</td>
														</tr>
														:
														<>
															<tr>
																<td>{item.fin_year}</td>
																<td>{item.name}</td>
																<td>{(item.link === '')?<>MENU</>:<>YES</>}</td>
																<td id={item.id}>
																	<span className='p-1'>
																		<Button id={`${item.id}|${item.name}|${item.fin_year}|${item.link}`} variant='info' size='small' onClick={this.handleShow} style={{padding:'0 3px'}}>
																			<BsPencilSquare/>
																		</Button>
																	</span>
																	<span className='p-1'>
																			<Button id={`${item.id}`} variant='danger' size='small' onClick={this.deleteMenu} style={{padding:'0 3px',backgroundColor:"red",borderColor:"red"}}>
																				<BsFillTrashFill/>
																			</Button>
																		</span>
																</td>
															</tr>
															{item.child.map(child=>
																<tr>
																	<td>{child.fin_year}</td>
																	<td>{child.name}</td>
																	<td>{(child.link === '')?<>MENU</>:<>YES</>}</td>
																	<td id={child.id}>
																		<span className='p-1'>
																			<Button id={`${child.id}|${child.name}|${child.fin_year}|${child.link}`} variant='info' size='small' onClick={this.handleShow} style={{padding:'0 3px'}}>
																				<BsPencilSquare/>
																			</Button>
																		</span>
																		<span className='p-1'>
																			<Button id={`${item.id}`} variant='danger' size='small' onClick={this.deleteMenu} style={{padding:'0 3px',backgroundColor:"red",borderColor:"red"}}>
																				<BsFillTrashFill/>
																			</Button>
																		</span>
																	</td>
																</tr>
															)}
														</>
													)}	
												</tbody>
											</Table>
										</Col>
									</Row>
								</Card.Body>
								</Card>
							</Col>
						</Row>			
					</Container>
				</div>
				<FooterComponent/>
				<Modal show={show} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Update Menu</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form onSubmit={this.onFileUpload}>
							<Form.Group className="mb-3">
								<Form.Label>Select Financial Year</Form.Label>
								<Form.Control type="text" placeholder="" value={finYear} readOnly/>
							</Form.Group>
							<Form.Control type="hidden" value={id} readOnly/>
							<Form.Group className="mb-3">
								<Form.Label>Title</Form.Label>
								<Form.Control type="text" placeholder="" value={this.state.title} onChange={this.onChangeTitle} />
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Select file to upload</Form.Label>
								<Form.Control type="file" size="sm" name="pdfFile" id="pdfFile" onChange={this.onFileChange} disabled={this.state.disable}/>
							</Form.Group>
							<Form.Group className="mb-3 text-end">
								<Button type="submit" className='text-end'>Save</Button>
							</Form.Group>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={this.handleClose}> Close </Button>
					</Modal.Footer>
				</Modal>
			</>
		)
	}
} 
 
export default DocumentListComponent